/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon32Regular = forwardRef('UiMenuDots8VIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M13 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M13 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M15 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M13 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M21 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M19 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M21 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M19 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
